import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Carteira, Container, TrocarCarteiraContainer, TrocarCarteiraText, StyledExchange, } from "./style";
import { LineSmall } from "../Line";
import { Link, useLocation } from "react-router-dom";
export default function TrocarCarteira({ displayCarteira, handleClick, unicaCarteira, }) {
    const { search, pathname } = useLocation();
    return (_jsxs(Container, Object.assign({ "data-html2canvas-ignore": "true" }, { children: [_jsxs(Carteira, { children: ["Carteira ", displayCarteira] }), unicaCarteira ? ("") : (_jsxs(TrocarCarteiraContainer, { children: [_jsxs(Link, Object.assign({ style: {
                            textDecoration: "none",
                            color: "inherit",
                            alignItems: "center",
                            display: "flex",
                        }, to: { pathname: "/", search }, state: pathname, onClick: handleClick }, { children: [_jsx(StyledExchange, {}), _jsx(TrocarCarteiraText, { children: "Trocar Carteira" })] }), "1"), _jsx(LineSmall, {})] }))] })));
}
